import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const deleteFundingRequest = createApiThunk<void, string>(
  "fundingRequests/deleteFundingRequest",
  async (id, { extra: { adminRepository } }) => {
    return adminRepository!.delete(id);
  },
);

export const resetDeleteFundingRequest = createAction("fundingRequests/resetDeleteFundingRequest");
